import axios from "axios";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { FormControl, InputGroup, Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { default as config } from "../config.json";
import useSampleProductsAndCategories from "../hooks/useSampleProductsAndCategories";
import "../ProductSampleListScreen.css";
import { Store } from "../Store";
import { getError } from "../utils";
import ProductSampleEditScreen from "./ProductSampleEditScreen";

const reducer = (state, action) => {
  switch (action.type) {
    case "DELETE_REQUEST":
      return { ...state, loadingDelete: true, successDelete: false };
    case "DELETE_SUCCESS":
      return {
        ...state,
        loadingDelete: false,
        successDelete: true,
      };
    case "DELETE_FAIL":
      return { ...state, loadingDelete: false, successDelete: false };

    case "DELETE_RESET":
      return { ...state, loadingDelete: false, successDelete: false };
    default:
      return state;
  }
};

export default function ProductSampleListScreen() {
  const [{ successDelete }, dispatch] = useReducer(reducer, {
    loadingCreate: false,
    loadingDelete: false,
    successDelete: false,
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductEditor, setShowProductEditor] = useState(false);
  const [query, setQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [
    loadingProducts,
    errorLoadingProducts,
    setLoadProducts,
    setLoadCategories,
    setLoadLeafCategories,
  ] = useSampleProductsAndCategories();

  const { state } = useContext(Store);
  const { userInfo, products } = state;

  useEffect(() => {
    const productsFiltered = products?.filter((p) =>
      query ? p.name.toLowerCase().includes(query.toLowerCase()) : true
    );
    setFilteredProducts(productsFiltered);
  }, [query, products]);

  const deleteHandler = async (product) => {
    if (window.confirm("Silmek istediginize emin misiniz?")) {
      try {
        dispatch({ type: "DELETE_REQUEST" });

        await axios.delete(`/api/productsamples/${product._id}`, {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });
        setLoadCategories(true);
        setLoadProducts(true);
        setLoadLeafCategories(true);
        toast.success("Ürün başarılı bir şekilde silindi");
        dispatch({ type: "DELETE_SUCCESS" });
      } catch (err) {
        toast.error(getError(err));
        dispatch({
          type: "DELETE_FAIL",
        });
      }
    }
  };

  const handleClickNewProduct = () => {
    setSelectedProduct(null);
    setShowProductEditor(true);
  };

  return (
    <div className="product-sample-grid-container">
      <Helmet>
        <title>Ürün Havuzu</title>
      </Helmet>
      {!isTabletOrMobile && (
        <>
          <h1 className="my-3 text-muted">Ürün Havuzu</h1>
          <hr className="hr"></hr>
        </>
      )}
      <div className="product-sample-grid-toolbar">
        <div>
          <InputGroup className="mb-3">
            <FormControl
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Urun ara..."
              aria-label="Urun ara"
              aria-describedby="button-search"
            ></FormControl>
            <Button variant="outline-primary" onClick={() => setQuery("")}>
              Temizle
            </Button>
          </InputGroup>
        </div>
        <div className="ms-auto">
          <Button
            type="button"
            onClick={handleClickNewProduct}
            className={"text-primary border-primary"}
            variant="light"
          >
            <i className="fas fa-plus"></i>
            {!isTabletOrMobile && <>&nbsp; Ürün Oluştur</>}
          </Button>
        </div>
      </div>

      <div className="product-sample-grid">
        {loadingProducts ? (
          <p>Loading...</p>
        ) : errorLoadingProducts ? (
          <p>Error loading products...</p>
        ) : filteredProducts && filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <div className="product-sample-card" key={product._id}>
              <img
                src={product.image || config.default_image}
                alt={product.name}
                className="product-sample-image"
                onClick={() => {
                  setSelectedProduct(product);
                  setShowProductEditor(true);
                }}
              />
              <h5 className="product-sample-name">{product.name}</h5>

              <Button
                variant="danger"
                onClick={() => deleteHandler(product)}
                className="delete-button"
              >
                Sil
              </Button>
            </div>
          ))
        ) : (
          <p>Sisteme kayıtlı ürün bulunamadı</p>
        )}
      </div>

      <Modal
        backdrop="static"
        show={showProductEditor}
        onHide={() => {
          setShowProductEditor(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {!selectedProduct ? "Yeni Ürün" : "Ürün Güncelle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProductSampleEditScreen
            isTabletOrMobile={isTabletOrMobile}
            setShowProductEditor={setShowProductEditor}
            product={selectedProduct || {}}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
